import { useUserInfo } from '@games/api';
import moment from 'moment';
import React, { FC, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import intlMessages from '../../../intl/messages';

const LS_KEY_DISMISS = 'daily_reminder_dismissed';
const LS_KEY_NEVER_SHOW = 'daily_reminder_never_show';

export const DailyHero: FC = () => {
  const [{ data: userInfo }] = useUserInfo();
  const today = moment().format('YYYY-MM-DD');
  const shouldDismiss = localStorage.getItem(LS_KEY_DISMISS) === today;
  const shouldNeverShow = localStorage.getItem(LS_KEY_NEVER_SHOW) === 'true';
  const [show, setShow] = useState(!shouldDismiss && !shouldNeverShow);
  const intl = useIntl();

  const playDaily = () => {
    window.location.href = `/${intl.locale}/daily`;
  };

  const dismiss = () => {
    localStorage.setItem(LS_KEY_DISMISS, today);
    setShow(false);
  };

  const neverShow = () => {
    localStorage.setItem(LS_KEY_NEVER_SHOW, 'true');
    setShow(false);
  };

  if (
    userInfo?.nonogramLastDailyDate === today ||
    shouldDismiss ||
    shouldNeverShow ||
    !show ||
    window.location.pathname?.endsWith('/daily')
  ) {
    return null;
  }

  return (
    <div
      className={
        'flex justify-between p-3 items-center ' +
        'bg-gradient-to-r from-slate-700 to-slate-800 text-slate-100 ' +
        'flex-col md:flex-row gap-4 md:gap-0'
      }
    >
      <h2 className='text-lg font-bold'>
        <FormattedMessage {...intlMessages.dontMissTodaysPuzzle} />
      </h2>
      <div className='flex gap-4 flex-row'>
        <button
          className='btn btn-primary bg-cyan-500 hover:bg-cyan-600 text-white'
          onClick={playDaily}
        >
          <FormattedMessage {...intlMessages.playToday} />
        </button>
        <button
          className='btn bg-slate-500 hover:bg-slate-600 text-white'
          onClick={dismiss}
        >
          <FormattedMessage {...intlMessages.dismiss} />
        </button>
        <button
          className='btn btn-danger bg-rose-500 hover:bg-rose-600 text-white'
          onClick={neverShow}
        >
          <FormattedMessage {...intlMessages.neverShowAgain} />
        </button>
      </div>
    </div>
  );
};
